<template>
    <article v-if="item" class="post-item" :class="['color-'+color, 'type-' + item.post_type, (item.event_location && item.event_location === 'lewes') ? 'color-lewes' : '', item.family_event ? 'post-item--family-event' : '', item.fringe_event ? 'post-item--fringe-event' : '', item.workshop_event ? 'post-item--workshop-event' : '']">
        <figure class="image" v-if="img">
            <router-link :to="link">
                <img :src="img">
            </router-link>
        </figure>
        <div class="col">
            <router-link :to="link">
                <time v-if="date_str">
                    {{date_str}}
                </time>
                <h2 class="post-title" v-html="title"></h2>
                <p class="number" v-if="item.part_number" v-html="item.part_number"></p>
                <div class="enter" v-html="excerpt"></div>
                <div class="more" v-if="item.post_type === 'stories'"><span>More</span></div>
            </router-link>
            <ul class="tags" v-if="tags.length !== 0 || (item.event_location && item.event_location === 'lewes')">
                <li v-for="(tag, index) in tags" :key="index">
                  <Button :size="'small'" :class="tag.class">{{tag.name}}</Button>
                </li>
                <li v-if="item.event_location && item.event_location === 'lewes'" >
                  <Button :size="'small'" :color="'black-full'">Lewes</Button>
                </li>
            </ul>
        </div>
    </article>
</template>

<script>
import Link from '@/components/ui/Link.vue';
import Button from '@/components/ui/Button.vue';
import FormatDate from '@/utils/FormatDate';

export default {
    name: 'post-item',
    components: {
        Link,
        Button,
    },

    props: {
        item: {
            type: Object,
            default: false,
        },
        color: {
            type: String,
            default: 'white',
        },
    },

    data() {
        return {
            img: '',
            date_str: '',
            title: '',
            excerpt: '',
            link: '',
            tags: [],
        }
    },

    mounted() {
        if (this.item.related_festival) this.tags.push({
          name: 'Festival',
          link: '',
        });


        switch (this.item.post_type) {
            case 'exhibition':
                this.tags.push({
                    name: 'Exhibition',
                    link: '/exhibitions',
                });
                break;
            // case 'event':
            //     this.tags.push({
            //         name: 'Event',
            //         link: '/events',
            //     });
            //     break;
            case 'festival':
                this.tags.push({
                    name: 'Festival',
                    link: '/festivals',
                });
                break;
            case 'podcasts':
                this.tags.push({
                    name: 'Podcast',
                    link: '/podcasts',
                });
                break;
            case 'people':
                this.tags.push({
                    name: 'People',
                    link: '/all-people',
                });
                break;
            case 'page':
                this.tags.push({
                    name: 'Other',
                    link: '/',
                });
                break;
        }


        if (this.item.sold_out) this.tags.push({
            name: 'Fully booked',
            class: 'sold-out',
            link: '/',
        });

        if (this.item.access && this.item.access.length !== 0) {
            this.item.access.forEach(item => {
                this.tags.push({
                    name: item.name,
                    class:'',
                    link: '/type/' + item.slug,
                });
            });
        }

        if (this.item.types && this.item.types.length !== 0) {
            this.item.types.forEach(item => {
                this.tags.push({
                    name: item.name,
                    class:'',
                    link: '/type/' + item.slug,
                });
            });
        }

        this.title = this.item.post_title;
        this.excerpt = this.item.post_excerpt;
        this.link = this.item.link.replace(window.globals.home_url, '');
        this.img = this.item.featured_image.medium_4x3;
        this.date_str = FormatDate(this.item);


    },
}
</script>

<style lang="scss" scoped>
    .post-item {
        position: relative;
        background: white;
        margin: var(--padding) auto;
        display: flex;
        width: 100%;
        min-height: 20rem;
        z-index: 1;

        .image {
            width: calc(50% - 3rem);
            position: relative;
            box-sizing: border-box;

            &::before {
                content: '';
                padding: 0 0 75%;
                display: block;
            }

            img {
                width: 100%;
                height: 100%;
                display: block;
                position: absolute;
                left: 0;
                top: 0;
                object-fit: cover;
            }
        }

        .col {
            box-sizing: border-box;
            padding: var(--padding) var(--padding) calc(var(--padding) - 1rem) var(--padding);
            flex: 1;
            min-height: 100%;
            display: grid;
            grid-template-rows: 1fr auto;
            grid-template-columns: 100%;

            a::before {
                position: absolute;
                left: 0;
                top: 0;
                height: 100%;
                width: 100%;
                z-index: 9;
                content: '';
            }
        }

        .enter {
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 3;
            -webkit-box-orient: vertical;
        }

        .post-title {
            text-align: center;
            margin: var(--padding) 0 var(--padding);
            font-size: var(--medium-size);
            line-height: 1.2;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 3;
            -webkit-box-orient: vertical;
            overflow: hidden;
        }

        .tags {
            padding: var(--padding) 0 0;
            display: flex;
            flex-wrap: wrap;

            li {
                padding: 0 var(--padding-50) var(--padding-50) 0;
            }

            span.ui-button {
                min-width: unset;
                margin-bottom: 0;
                &:hover {
                    color: black;
                    background-color: white;
                    border-color: black;
                    cursor: default;
                }
            }

            span.sold-out {
                color: white;
                background: black;
                border-color: black;
                &:hover {
                    color: white;
                    background-color: black;
                }
            }
        }

        &.color-lewes {
          background-color: var(--theme-2-color-1);
        }

        // &.post-item--family-event {
        //   background-color: var(--theme-1-color-6);
        // }

        // &.post-item--workshop-event {
        //   background-color: var(--theme-1-color-5);
        // }

        // &.post-item--fringe-event {
        //   background-color: #ff96dc;
        // }

        &.color-black {
            background: black;

            a {
                color: white;
            }

            .tags {
                span.ui-button {
                    background-color: black;
                    color: white;
                    border-color: white;

                    &:hover {
                        background: black;
                        color: white;
                        border-color: white;
                        cursor: default;
                    }

                    &.sold-out {
                        color: black;
                        background: white;
                        border-color: white;
                    }
                }
            }
        }

        &.type-stories {
            a:hover {
                color: unset;
            }
            .col {
                padding-top: 0;
                padding-bottom: 0;
                display: flex;
                align-items: center;
                justify-content: center;
            }

            .post-title {
                padding: 0;
                text-align: left;
                margin: 0 0 var(--padding);
                -webkit-line-clamp: 2;
            }

            .number {
                color: var(--gray);
                font-size: var(--medium-size);
                margin-top: -.8em;
            }

            .enter {
                margin: var(--padding) 0 0;
            }

            .more {
                text-align: center;
                padding-top: var(--padding);

                span {
                    border-bottom: 1px solid;
                }
            }
        }

        &:hover {
            .tags {
                opacity: .5;
            }
        }
    }

    @media only screen and (max-width: 767px) {
        .post-item {
            margin: var(--padding) 0;
            display: block;
            min-height: unset;
            width: auto;

            .image {
                width: 100%;
                position: relative;
                box-sizing: border-box;

                &::before {
                    content: '';
                    padding: 0 0 75%;
                    display: block;
                }
            }

            &.type-stories {
                .col {
                    padding-top: var(--padding);
                    padding-bottom: var(--padding);
                }
            }

            .enter {
                -webkit-line-clamp: 9;
            }

            .post-title {
                -webkit-line-clamp: 9;
            }

            .tags {
                li {
                    padding-right: var(--padding-50);
                }
            }

        }

    }
</style>
